import { cn } from '@/lib/utils';
import { TransactionTypeEnum } from '@/enums';

type TProps = {
  type: TransactionTypeEnum;
}

export const TypeBadge = ({ type }: TProps) => {
  const isIncome = type === TransactionTypeEnum.INCOME;
  return (
    <span className={cn('font-semibold text-xs uppercase tracking-wider', isIncome ? 'text-emerald-500' : 'text-red-500')}>
      {isIncome ? 'Revenu' : 'Dépense'}
    </span>
  );
};
